import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=1f08e976&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"
import style0 from "./Test.vue?vue&type=style&index=0&id=1f08e976&prod&scoped=scoped&lang=less"
import style1 from "./Test.vue?vue&type=style&index=1&id=1f08e976&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08e976",
  null
  
)

export default component.exports